import { render } from "./Main.vue?vue&type=template&id=5005e548"
const script = {}
script.render = render

export default script